module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_8019.8fd721cd.png";